import { api } from '../api';

export const API_PUBLIC_VOD_PATH = '/public/vod';

export const fetchAllVodByChannelId = (channelId, ignoreFolders, folderId) => api.get(
	`${API_PUBLIC_VOD_PATH}/byChannel/${channelId}/all`,
	{ params: { folderId, ignoreFolders } },
);

export const fetchAllFeaturedVodsByChannelId = (channelId) => api.get(
	`${API_PUBLIC_VOD_PATH}/byChannel/${channelId}/featured`,
);
